var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadedInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1301_17609)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.9375C6.31066 0.9375 6.5625 1.18934 6.5625 1.5V3C6.5625 3.31066 6.31066 3.5625 6 3.5625C5.68934 3.5625 5.4375 3.31066 5.4375 3V1.5C5.4375 1.18934 5.68934 0.9375 6 0.9375Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58053 2.41939C9.8002 2.63906 9.8002 2.99522 9.58053 3.21489L8.52116 4.27426C8.30149 4.49393 7.94534 4.49393 7.72567 4.27426C7.506 4.05459 7.506 3.69844 7.72567 3.47877L8.78504 2.41939C9.00471 2.19972 9.36086 2.19972 9.58053 2.41939Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4375 6C8.4375 5.68934 8.68934 5.4375 9 5.4375H10.5C10.8107 5.4375 11.0625 5.68934 11.0625 6C11.0625 6.31066 10.8107 6.5625 10.5 6.5625H9C8.68934 6.5625 8.4375 6.31066 8.4375 6Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72567 7.72567C7.94534 7.506 8.30149 7.506 8.52116 7.72567L9.58053 8.78504C9.8002 9.00471 9.8002 9.36086 9.58053 9.58053C9.36086 9.8002 9.00471 9.8002 8.78504 9.58053L7.72567 8.52116C7.506 8.30149 7.506 7.94534 7.72567 7.72567Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8.4375C6.31066 8.4375 6.5625 8.68934 6.5625 9V10.5C6.5625 10.8107 6.31066 11.0625 6 11.0625C5.68934 11.0625 5.4375 10.8107 5.4375 10.5V9C5.4375 8.68934 5.68934 8.4375 6 8.4375Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27432 7.72567C4.49399 7.94534 4.49399 8.30149 4.27432 8.52116L3.21495 9.58053C2.99528 9.8002 2.63912 9.8002 2.41945 9.58053C2.19978 9.36086 2.19978 9.00471 2.41945 8.78504L3.47883 7.72567C3.6985 7.506 4.05465 7.506 4.27432 7.72567Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.9375 6C0.9375 5.68934 1.18934 5.4375 1.5 5.4375H3C3.31066 5.4375 3.5625 5.68934 3.5625 6C3.5625 6.31066 3.31066 6.5625 3 6.5625H1.5C1.18934 6.5625 0.9375 6.31066 0.9375 6Z",
    fill: "black",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41945 2.41939C2.63912 2.19972 2.99528 2.19972 3.21495 2.41939L4.27432 3.47877C4.49399 3.69844 4.49399 4.05459 4.27432 4.27426C4.05465 4.49393 3.6985 4.49393 3.47883 4.27426L2.41945 3.21489C2.19978 2.99522 2.19978 2.63906 2.41945 2.41939Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1301_17609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadedInvoice);
export default __webpack_public_path__ + "static/media/loaded-invoice.19cc63ff.svg";
export { ForwardRef as ReactComponent };